import { render, staticRenderFns } from "./editUnionPurOrders_v2.vue?vue&type=template&id=308bf0f7&scoped=true&"
import script from "./editUnionPurOrders_v2.vue?vue&type=script&lang=js&"
export * from "./editUnionPurOrders_v2.vue?vue&type=script&lang=js&"
import style0 from "./editUnionPurOrders_v2.vue?vue&type=style&index=0&id=308bf0f7&lang=less&scoped=true&"
import style1 from "./editUnionPurOrders_v2.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308bf0f7",
  null
  
)

component.options.__file = "editUnionPurOrders_v2.vue"
export default component.exports